import { Injectable } from '@angular/core';
import { CountryCode } from '../models/country-code';
import { LanguageCode } from '../models/language-code';

/**
 * Provides various constants to applications using the library.
 */
@Injectable({
    providedIn: 'root',
})
export class ConstantsService {
    public static readonly EMPTY_STRING: string = '';
    public static readonly SIDENAV_BREAKPOINT: number = 986; // [px]
    public static readonly SIDENAV_WIDTH: number = 300; // [px]
    public static readonly TOOLBAR_BREAKPOINT: number = 600; //[px]

    public static readonly TOOLBAR_STANDARD_HEIGHT: number = 64; // [px]
    public static readonly TOOLBAR_MOBILE_HEIGHT: number = 56; // [px]

    public static readonly FILTER_DEBOUNCE_TIME: number = 300; // [ms] Debounce time for filtering functionality within CZ

    // for unlimited review message queries, processable by BE's MAX_INT
    public static readonly MAX_INT = 2 ** 31 - 1;

    // Defined by BE validation
    public static readonly MAX_PAGING_ITEMS = 1000;

    public static readonly MAIN_ID: string = 'main'; // [-]

    public static readonly NOTIFICATIONS_TO_DISPLAY: number = 4; // [1]

    public static readonly TOAST_KEY: string = 'apcam-toast'; // [-]
    public static readonly ADMIN_ERROR_TOAST_KEY: string =
        ConstantsService.TOAST_KEY; // [-]
    public static readonly CLIENT_ERROR_TOAST_KEY: string =
        'apcam-client-error-toast'; // [-]

    public static readonly CAN_DEACTIVATE_CONFIRM_KEY: string =
        'can-deactivate-confirm';

    public static readonly COPIED_TOOLTIP_HIDE_DELAY: number = 2500; // [ms]
    public static readonly CHIP_ERROR_HIGHLIGHT_TIME: number = 2000; // [ms]

    public static readonly DEFAULT_DECIMAL_POINTS: number = 3; // [1]

    public static readonly SUPPORT_CONTACT_EMAIL: string = 'info@lemunzo.com'; // [-]

    public static readonly DEFAULT_LANG: LanguageCode = 'en' as LanguageCode;
    public static readonly DEFAULT_COUNTRY: CountryCode = 'cz' as CountryCode;

    public static readonly NAVIGATION_CASE_NAME_PLACEHOLDER = 'NAV_CASE_NAME';

    public static readonly REGISTRATION_FORM_DEFAULT_CATEGORY_NAME = 'default';

    // String lengths; define common max lengths for string fields in BE models (and, thus, DB)
    public static readonly STRING_LENGTH_SHORTCUT = 5;
    public static readonly STRING_LENGTH_SHORT = 50;
    public static readonly STRING_LENGTH_MEDIUM = 250;
    public static readonly STRING_LENGTH_LONG = 4000;

    public static readonly TEXTAREA_ROWS_DEFAULT = 2;
    public static readonly TEXTAREA_ROWS_SHOW_HINT = 10;

    public static readonly CHECKBOX_PREFIX = '~CHKBX~';
    public static readonly CHECKBOX_SEPARATOR = ';';
}
